/**
 * shared-cs `NamesDef` (content section `names`, CONTRACT §13.5): the 1960s-American name pools `Names/NameFactory` draws from to name
 * every survivor and NPC made without a curated name (the Stranger, raid recruits, stragglers, occupied crews, dev survivors). Story cast
 * and QR copies keep their own names. Typed locally until the API client is regenerated.
 */
export type NamesDef = {
  /** Men's first names ("Walt", "Earl"). */
  male?: (string | null)[] | null;
  /** Women's first names ("Peggy", "Dolores"). */
  female?: (string | null)[] | null;
  /** Last names ("Jennings", "Marsh"). */
  last?: (string | null)[] | null;
};

/** The three lists, in the validator's order. */
export const NAME_LISTS = ['male', 'female', 'last'] as const;
export type NameListKey = (typeof NAME_LISTS)[number];

/** The C# defaults: every list EMPTY (an empty section names everyone "Survivor", and the validator refuses it). */
export const namesDefaults = (): NamesDef => ({ male: [], female: [], last: [] });

/** A pasted column (one name per line; commas and tabs split too), trimmed, blanks dropped. */
export const parseNameColumn = (text: string) =>
  text
    .split(/[\r\n,\t]+/)
    .map((n) => n.trim())
    .filter((n) => n !== '');
